import { Component, OnInit } from '@angular/core';
import { RouteAuthorizationService } from '../../services/route-authorization.service';

@Component({
  selector: 'app-get-started',
  templateUrl: './get-started.component.html',
  standalone: false
})
export class GetStartedComponent implements OnInit {
  // Track which routes the user can access
  canAccessDevices = false;
  canAccessDownloads = false;
  canAccessAds = false;
  canAccessPassPrediction = false;
  canAccessDeliveryStatus = false;
  canAccessAlmanac = false;

  constructor(private routeAuthService: RouteAuthorizationService) {}

  async ngOnInit() {
    await this.checkRouteAccess();
  }

  private async checkRouteAccess() {
    // Check each route using the convenient string path API
    this.canAccessDevices = await this.routeAuthService.checkCanActivate('devices');
    this.canAccessDownloads = await this.routeAuthService.checkCanActivate('downloads');
    this.canAccessAds = await this.routeAuthService.checkCanActivate('ads');
    this.canAccessPassPrediction = await this.routeAuthService.checkCanActivate('pass_prediction');
    this.canAccessDeliveryStatus = await this.routeAuthService.checkCanActivate('delivery_status');
    this.canAccessAlmanac = await this.routeAuthService.checkCanActivate('almanac');
  }
}
